<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: "您参与滑翔翼运动有多频密？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideHowOftenCN`,
					props: {
						suggest: {
							typeIncludes: `hangGlideHowOftenCN`
						},
						createOptions: {
							type: `hangGlideHowOftenCN`,
							dataType: "string"
						}
					}
				},
				{
					label: " 您在何处进行滑翔翼运动？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideLocationCN`,
					props: {
						suggest: {
							typeIncludes: `hangGlideLocationCN`
						},
						createOptions: {
							type: `hangGlideLocationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否滑翔翼组织的会员？ ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isMemberOfHangGlideClubCN`,
					props: {
						suggest: {
							typeIncludes: `isMemberOfHangGlideClubCN`
						},
						createOptions: {
							type: `isMemberOfHangGlideClubCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "您是否进行专业滑翔翼运动？ ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isProHangGlideCN`,
					props: {
						suggest: {
							typeIncludes: `isProHangGlideCN`
						},
						createOptions: {
							type: `isProHangGlideCN`,
							dataType: "boolean"
						}
					}
				},

				{
					label: "您可以飞多高？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideHowHighCN`,
					props: {
						suggest: {
							typeIncludes: `hangGlideHowHighCN`
						},
						createOptions: {
							type: `hangGlideHowHighCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您的最高飞行高度？ ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideGreatestHeightCN`,
					props: {
						suggest: {
							typeIncludes: `hangGlideGreatestHeightCN`
						},
						createOptions: {
							type: `hangGlideGreatestHeightCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您的最远飞行距离？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideGreatestDistanceCN`,
					props: {
						suggest: {
							typeIncludes: `hangGlideGreatestDistanceCN`
						},
						createOptions: {
							type: `hangGlideGreatestDistanceCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您的最长飞行时间？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hangGlideLongestDurationCN`,
					props: {
						suggest: {
							typeIncludes: `hangGlideLongestDurationCN`
						},
						createOptions: {
							type: `hangGlideLongestDurationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您曾否或是否试图达到某个高度、距离或时间的纪录？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasIntentAttemptHangGlideRecordCN`,
					props: {
						suggest: {
							typeIncludes: `hasIntentAttemptHangGlideRecordCN`
						},
						createOptions: {
							type: `hasIntentAttemptHangGlideRecordCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0attemptHangGlideRecordDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `attemptHangGlideRecordDetailsCN`
						},
						createOptions: {
							type: `attemptHangGlideRecordDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您曾否或是否试图以制造商或自行设计的实验滑翔翼器材飞行?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasIntentAttemptExperimentalHangGlideCN`,
					props: {
						suggest: {
							typeIncludes: `hasIntentAttemptExperimentalHangGlideCN`
						},
						createOptions: {
							type: `hasIntentAttemptExperimentalHangGlideCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0attemptExperimentalHangGlideDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `attemptExperimentalHangGlideDetailsCN`
						},
						createOptions: {
							type: `attemptExperimentalHangGlideDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
